import { SemanticVersion } from '@hediet/semver';

export const runtimeVersion = SemanticVersion.parse('1.0.0');

